import { VISA } from '../../constants/partnering-networks';
import { trackIdentityLookup } from '../../helpers/gtm';
import OrchCustomData from '../../helpers/orch-custom-data';
import validateIdentityLookupData from '../../helpers/validate-identity-lookup-data';
import identityLookup from '../identity-lookup';

/*
 * Buttonless wrapper for identityLookup api.
 * This is what is bound to "V" namespace for merchant to
 * call in integrated Vsb flows. Wrapper is needed to keep
 * integrated/buttonless specific logic and response handling
 * separate from identityLookup orch api
 */
const identityLookupForButtonless = (data = {}) => {
  return new Promise(resolve => {
    let vsbGtmData = { isError: false, isRequest: true, isVsb: true };
    trackIdentityLookup(data, OrchCustomData, vsbGtmData, '');
    const errorMessage = validateIdentityLookupData(data);
    if (errorMessage) {
      vsbGtmData = { isError: true, isRequest: false, isVsb: true };
      trackIdentityLookup(data, OrchCustomData, vsbGtmData, VISA);
      resolve({ error: { reason: errorMessage } });
      return;
    }
    identityLookup(data).then(identityResponse => {
      resolve(identityResponse);
    });
  });
};

export default identityLookupForButtonless;
